import * as angular from "angular";
import { PermissionCheck } from "../../../shared/permission";
import { CanvasserTrackingDataProvider } from "../../../data-provider/canvasser-tracking.dp";
import { CanvassDataProvider } from "../../../data-provider/canvass.dp";
import { User } from "../../../models/user.model";
import { DashboardWidgetFilter } from "../../../models/dashboard-widget-filter.model";
import { Dashboard } from "../../../models/dashboard.model";

let CanvasserTrackingWidgetUsersComponent = {
    selector: "vcCanvasserTrackingWidgetUsers",
    templateUrl:
        "/angular/components/canvasser-tracking/widget/canvasser-tracking-widget-users.component.html",
    bindings: {
        users: "=",
        filter: "=",
        dashboard: "=",
        mode: "=?",
    },
    controller: class CanvasserTrackingWidgetUsersController {
        // * bindings for typescript compiler *
        public filter?: DashboardWidgetFilter;
        public users?: User[];
        public dashboard: Dashboard;
        // ************************************

        private readonly modelsUtils: any;

        public loading: boolean = true;
        public dataProvider: CanvasserTrackingDataProvider;
        public canvassDataProvider: CanvassDataProvider;
        public permissionProvider: PermissionCheck;

        constructor(
            CanvasserTrackingDataProvider: CanvasserTrackingDataProvider,
            CanvassDataProvider: CanvassDataProvider,
            PermissionCheck: PermissionCheck,
            ModelsUtils: any
        ) {
            this.modelsUtils = ModelsUtils;

            this.dataProvider = CanvasserTrackingDataProvider;
            this.canvassDataProvider = CanvassDataProvider;
            this.permissionProvider = PermissionCheck;
            this.permissionProvider.getFeaturePermissions();
        }

        filtersToPassToTrackingPage() {
            return {
                dateRange: this.filter.dateRange,
            };
        }

        userIsOnline(user: User): boolean {
            if (!user || !user.last_canvass) {
                return false;
            }

            let date_string = user.last_canvass.cscreationdatetime.replace(
                /-/g,
                "/"
            );
            let nowDate = new Date();
            let nowTime = nowDate.setTime(nowDate.getTime());
            let date = new Date(date_string).getTime();

            let dateDifference = nowTime - date;
            let minutes = Math.abs(dateDifference) / 1000 / 60;

            return minutes < 60;
        }

        getName(person: any): string {
            person = this.modelsUtils.houseOccupant(person);
            return person.identifier();
        }

        generateLink(user: User): string {
            if (
                this.permissionProvider.hasPermission(
                    "CANVASSER_TRACKING_ALLOWED"
                ) ||
                this.dashboard.location == "user"
            ) {
                return (
                    "/#/canvasser/activity?user=" +
                    user.uid +
                    "&filter=" +
                    JSON.stringify(this.filtersToPassToTrackingPage())
                );
            } else {
                return "/#/user/" + user.uid;
            }
        }
    },
};

angular
    .module("canvasserTracking")
    .component(
        CanvasserTrackingWidgetUsersComponent.selector,
        CanvasserTrackingWidgetUsersComponent
    );
